import { Tooltip } from 'antd'
import classNames from 'classnames'
import { MyForm } from '~/components/ui/MyForm'
import { QuestionCircleOutlined } from '@ant-design/icons'
import styles from '../AiForm.module.css'
import { pretreatmentMethodAtom } from './atom'
import { useAtom } from 'jotai'
import { MyCheckbox } from '~/components/ui/MyCheckbox'
import { PretreatmentMethod } from '~/graphqls/types'

export const PreProcessSwitchComp = () => {
  const [pretreatmentMethod, setPretreatmentMethod] = useAtom(
    pretreatmentMethodAtom
  )

  return (
    <MyForm.Item
      required
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 6 }}
      label={
        <span>
          图片需要预处理{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="图片需要预处理会先生成预处理图，再生成结果图，如果你上传的就是一张预处理图，不需要预处理可直接生成结果图"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(
        styles.borderLessFormItem,
        '!mb-3',
        styles.inlineFormItem
      )}
    >
      <MyCheckbox
        $dark
        checked={pretreatmentMethod !== PretreatmentMethod.NONE}
        onChange={e => {
          const checked = e.target.checked
          if (checked) {
            // none 不需要预处理
            // undefined 需要预处理
            setPretreatmentMethod?.(undefined)
          } else {
            setPretreatmentMethod?.(PretreatmentMethod.NONE)
          }
        }}
      />
    </MyForm.Item>
  )
}
